import React from 'react';
import PropTypes from 'prop-types';

import {
  selectRequestState,
  sendRequest
} from 'mt-react-common/modules/contests/reducers/static/forms/participateContest/participateContestForm';
import { connect } from 'react-redux';

const participateContestFormRN = 'contests.forms.participateContestForm';

export default function createContainer(ChildContainer) {
  const ParticipateContestFormContainer = props => (
    <ChildContainer {...props} />
  );
  ParticipateContestFormContainer.propTypes = {
    // IN
    contestId: PropTypes.number.isRequired,

    // CONNECT DISPATCH
    sendRequest: PropTypes.func.isRequired
  };

  const mapStateToProps = state => ({
    requestState: selectRequestState(state, participateContestFormRN)
  });

  const mapDispatchToProps = (dispatch, props) => ({
    sendRequest: () =>
      dispatch(sendRequest(participateContestFormRN, props.contestId))
  });
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(ParticipateContestFormContainer);
}



// WEBPACK FOOTER //
// ./src/components/Contest/containers/ParticipateContestFormContainer/ParticipateContestFormContainer.js